import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import LogoutIcon from "@mui/icons-material/Logout";

import {logo, logo111 } from "../../assets/img";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";

import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";


import UploadFileIcon from "@mui/icons-material/UploadFile";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";

import ReceiptIcon from "@mui/icons-material/Receipt";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";

import FactCheckIcon from "@mui/icons-material/FactCheck";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";

const ProfileNavbar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [popup, setPopup] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;




  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleLogout = () => {
    navigate("/");
    setPopup(false);
  };

  return (
    <div className={sidebarOpen ? "sidebar" : "close_sidebar"}>
      {/* ================= HEADER ================= */}
        <header>
        <div className="image_text pointer d-flex ac-jc mt-2 Header_title">
          {sidebarOpen ? (
            <img src={logo} className="Login_title1" alt="logo" />
          ) : (
<img className="logo111" src={logo111} alt="logo" />          )}
        </div>
      </header>

     {/* TOGGLE */}
      <div onClick={toggleSidebar} className="toggle_sidebar pointer">
        {sidebarOpen ? (
          <KeyboardDoubleArrowLeftIcon className="lefticonarrow" />
        ) : (
          <KeyboardDoubleArrowRightIcon className="righticonarrow" />
        )}
      </div>

      <div className="menu_bar">
        <ul className="menu_links ps-0">

          <li className="nav_link" onClick={() => navigate("/employee/dashboard")}>
            <h4 className={`ps-3 ${currentPath === "/employee/dashboard" ? "active_bar" : ""}`}>
             {currentPath === "/employee/dashboard" ? (
                <DashboardIcon className="icon active_icon" />
              ) : (
                <DashboardOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Dashboard</span>
            </h4>
          </li>

          <li className="nav_link" onClick={() => navigate("/profile")}>
            <h4
              className={`ps-3 ${currentPath === "/profile" || currentPath.startsWith("/register-view")
                ? "active_bar"
                : ""
                }`}
            >
                {currentPath === "/profile" ? (
                <AdminPanelSettingsIcon className="icon active_icon" />
              ) : (
                <AdminPanelSettingsOutlinedIcon className="icon" />
              )}
           
              <span className="text ps-1">Profile</span>
            </h4>
          </li>

          <li className="nav_link" onClick={() => navigate("/attendance")}>
            <h4 className={`ps-3 ${currentPath === "/attendance" ? "active_bar" : ""}`}>
             {currentPath === "/attendance" ? (
                <FactCheckIcon className="icon active_icon" />
              ) : (
                <FactCheckOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Attendance</span>
            </h4>
          </li>
          <li className="nav_link" onClick={() => navigate("/time-sheet")}>
            <h4 className={`ps-3 ${currentPath === "/time-sheet" ? "active_bar" : ""}`}>
              {currentPath === "/time-sheet" ? (
                <ReceiptIcon className="icon active_icon" />
              ) : (
                <ReceiptOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Time Sheet</span>
            </h4>
          </li>
          <li className="nav_link" onClick={() => navigate("/document-view")}>
            <h4 className={`ps-3 ${currentPath === "/document-view" ? "active_bar" : ""}`}>
              {currentPath === "/document-view" ? (
                <UploadFileIcon className="icon active_icon" />
              ) : (
                <UploadFileOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Document</span>
            </h4>
          </li>
           <li className="nav_link" onClick={() => navigate("/employee-salary-list")}>
            <h4 className={`ps-3 ${currentPath === "/employee-salary-list" ? "active_bar" : ""}`}>
              {currentPath === "/employee-salary-list" ? (
                <UploadFileIcon className="icon active_icon" />
              ) : (
                <UploadFileOutlinedIcon className="icon" />
              )}
              <span className="text ps-1">Salary Detail</span>
            </h4>
          </li>

         
        </ul>
      </div>

      <div className="d-flex ac-jb py-3 px-2 bg-primary2 pointer" onClick={() => setPopup(true)}>
        <h4 className="f4 mb-0 ms-4">Logout</h4>
        <LogoutIcon />
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p>Are you sure you want to logout?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setPopup(false)} className="no-btn w-40">No</button>
              <button onClick={handleLogout} className="yes-btn w-40">Yes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileNavbar;
